<div class="col-md-12 clear-all" *ngIf="controlTypeQuestionList" [formGroup]="parentForm">
  <ng-container *ngFor="let question of controlTypeQuestionList; let i = index">
    <div [ngClass]="(question['controlStyle'] === 'InputBox_2numbers' ||
    question['controlStyle'] === 'InputBox_3numbers')?'containerTypes-new col-md-12 clear-all':'col-md-12 clear-all'">

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'Toggle_standard'">
        <fieldset role="group">
        <app-toggle-standard [question]="question" [indexToAppend]="tabIndexNumber" [objToReferToRetainValueFromTabSquare]="objToReferToRetainValueFromTabSquare"
          [objToReferForAccord]="objToReferToRetainValueForAccord" [accordIndexToAppend]="accordIndexToAppend" (toggleOptionHandler)="onChangeOfToggleStandardBtn($event, question, question.id, errorValue)"
          [parent]="parentForm" [editMode] = "editMode" (editModelHandler)="showEditAlert($event)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)">
        </app-toggle-standard>
        <div class="col-md-12 clear-all float-left dependentQues-new">
          <ng-template dependent-questions-dir></ng-template>
          <ng-container>
            <div *ngIf="parentForm && parentForm.touched && parentForm.get(question.id).errors" class="col-md-12 form-validation-error">
              <i class="icon icon-error" aria-hidden="true "></i>
              <p *ngIf="parentForm.touched && parentForm.get(question.id).errors.required ">Please enter a value</p>
              <p *ngIf="parentForm.touched && parentForm.get(question.id).errors.invalidPattern">{{getCustomToggleError(question.id)}}</p>
            </div>
          </ng-container>
        </div>
        </fieldset>
      </div>
      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'Grid_standard'">
        <fieldset role="group">
        <app-grid-tiles-new [parent]="parentForm.get(question.id)" [question]="question" 
        [gridTiles]="getNextStepGridOptions(question)" [editMode] = "editMode"
        (editModelHandler)="showEditAlert($event)" (GridCustomErrorEvent)="setGridTileCustomError($event)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)"></app-grid-tiles-new>
        <ng-container *ngIf="parentForm && parentForm.get(question.id).errors && parentForm.get(question.id).errors.invalid">
          <div class="col-md-12 form-validation-error">
            <i class="icon icon-error" aria-hidden="true "></i>
            <p *ngIf="question['sectionNameToRefer'] === 'drinkingHabits'">{{healthData.invalidAlcoholError}}</p>
          </div>
        </ng-container>
      </fieldset>
      </div>

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'DropDown_date'">
        <app-date-dropdown [accordIndexToAppend]="accordIndexToAppend" [indexToAppend]="tabIndexNumber" [parent]="getParentFormForChildComp(question.id, accordIndexToAppend)"
          [question]="question" [parentForm]="parentForm" [objToReferForAccord]="objToReferToRetainValueForAccord"
          [editMode] = "editMode" (editModelHandler)="showEditAlert($event)"></app-date-dropdown>
      </div>

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'Tab_square'" validation-tab-square-dir>
        <div class="Rectangle_new">
          <app-tab-square-button 
            [parent]="parentForm" 
            [tabSquareQuesObj]="question" 
            [editMode]="editMode"
            [resetTabSquare]="resetTabSquare" 
            [accordIndexToAppend]="accordIndexToAppend"
            (addTabSquareEmitter)="addTabSquareCallBack($event, question, question.id)"
            [objToReferForAccord]="objToReferToRetainValueForAccord"
            (tabSquareEmitter)="tabSquareCallBack($event, question, question.id)" 
            (editModelHandler)="showEditAlert($event)"
            (switchTabSquareEmitter)="switchTabSquareCallBack($event, question, question.id)"
            (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)"></app-tab-square-button>
            <div class="dependentQues col-md-12 clear-all" id="click-question">
            <ng-template dependent-questions-dir></ng-template>
          </div>
        </div>
      </div>

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'Accordion_standard'">
        <div class="positioningTabSquare Accordion_new">
          <accord class="panel panel-default" [parent]="parentForm"  [editMode]="editMode" [accordionQuesObj]="question" [accordIndexToAppend]="accordIndexToAppend"
          (editModelHandler)="showEditAlert($event)" (accordionEmitter)="accordionCallBack($event, question)" (addAccordionEmitter)="addAccordionCallBack($event, question)"
            (deleteAccordionEmitter)="deleteAccordionCallBack($event, question)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)"></accord>
          <div class="dependentQues-accordion">
            <ng-template dependent-questions-dir></ng-template>
          </div>
        </div>
      </div>

      <div class="" *ngIf="question['controlStyle'] === 'DropDown_standard'"
       [ngClass]="pageName === 'activities-of-daily-living' || pageName === 'dependant-activities-of-daily-living' ? 'col-md-12 clear-all margin-top-10 mar-btm-10' : 'col-md-12 clear-all margin-top-10' ">
        <app-dropdown-standard [indexToAppend]="tabIndexNumber" [objToReferToRetainValueFromTabSquare]="objToReferToRetainValueFromTabSquare"
          [label]="question.questionText" [question]="question" [parent]="parentForm" [objToReferForAccord]="objToReferToRetainValueForAccord"
          [accordIndexToAppend]="accordIndexToAppend" [emitAccordionTitleFromChild]="emitAccordionTitleFromChild" (selectedValChange)="selectedValueofDropdown($event, question, question.id)"
          [editMode] = "editMode"  [pageName] = pageName (editModelHandler)="showEditAlert($event)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)">
        </app-dropdown-standard>
        <div class="dependentQues-new">
          <ng-template dependent-questions-dir></ng-template>
        </div>
      </div>

      <div class="col-md-12 clear-all margin-top-10" *ngIf="question['controlStyle'] === 'RadioButton_square'">
        <div class="col-md-12 clear-all">
          <!--  margin-top--20 -->
          <app-question [givenQuestion]="question" [questionConfig]="radioQuestionList[question.id] ? radioQuestionList[question.id] : null"
            [childId]="'radioBtnQues'" [objToReferToRetainValueFromTabSquare]="objToReferToRetainValueFromTabSquare" [indexToAppend]="tabIndexNumber"
            [accordIndexToAppend]="accordIndexToAppend" [objToReferForAccord]="objToReferToRetainValueForAccord" [parent]="parentForm"
            [controlName]="getControlNameToSetRadBtnSqr(question.id)" (toggleChange)="toggleChangeOfRadioBtn($event, question, question.id)"
            [editMode] = "editMode" (editModelHandler)="showEditAlert($event)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)">
          </app-question>
          <div class="col-md-12 clear-all">
            <ng-template dependent-questions-dir></ng-template>
          </div>
        </div>
      </div>


      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'InputBox_standard' || question['controlStyle'] === 'InputBox_2numbers' ||
			question['controlStyle'] === 'InputBox_3numbers' || question['controlStyle'] === 'InputBox_image_3number'">
        <app-input [indexToAppend]="tabIndexNumber" [accordIndexToAppend]="accordIndexToAppend" [question]="question" [parent]="parentForm"
          [toggleBtnFlag]="toggleBtnFlag" [objToReferForAccord]="objToReferToRetainValueForAccord" [errorValue]="errorValue"
          (textChangeEventEmitter)="checkFormValid($event, toggleButtonQuesObj)">
        </app-input>
      </div>

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'Search_standard'">
        <app-input-search [accordIndexToAppend]="accordIndexToAppend" [indexToAppend]="tabIndexNumber" [objToReferToRetainValueFromTabSquare]="objToReferToRetainValueFromTabSquare"
          [question]="question" [parent]="parentForm" [objToReferForAccord]="objToReferToRetainValueForAccord" (selectedData)="selectedValueofSearchInput($event, question, question.id)"
          [editMode] = "editMode" (editModelHandler)="showEditAlert($event)"></app-input-search>
        <div class="dependentQues-new">
          <ng-template dependent-questions-dir></ng-template>
        </div>
      </div>

      <div  *ngIf="question['controlStyle'] === 'textOnly'"
       [ngClass]="pageName === 'activities-of-daily-living' || pageName === 'dependant-activities-of-daily-living' ? 'col-md-12 clear-all margin-bottom-4' : 'col-md-12 clear-all margin-bottom-20' ">
        
        <app-text-only [question]="question" [parent]="parentForm" [pageName] = pageName  [controlName]="question.id" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)">
        </app-text-only>
      </div>

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'CheckBox_standard' || 
      question['controlStyle'] === 'CheckBox_withSubquestions_DropDown_standard' || question['controlStyle'] ===  'CheckBox_withSubquestions'">
        <app-checkbox [question]="question" [parent]="parentForm" [controlName]="question.id" (selectedValChange)="selectedValueofCheckbox($event, question, question.id)"
        [editMode] = "editMode" (editModelHandler)="showEditAlert($event)" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)">
        </app-checkbox>
        <div class="dependentQues-new">
          <ng-template dependent-questions-dir></ng-template>
        </div>
      </div>

      <div class="row controlStyle-container" *ngIf="question['controlStyle'] === 'RadioButton_standard'">
        <app-radio-button-dot [config]="question" [parent]="parentForm.get(question.id)" [parentControlName]="question.id" [radioList]="prepareListForRadioStad(question)"
          [defaultSelectedValue]=""></app-radio-button-dot>
      </div>

      <div class="col-md-12 clear-all" *ngIf="question['controlStyle'] === 'DayMonthYearTextBox'">
        <app-multiple-inputbox [question]="question" [indexToAppend]="tabIndexNumber" [parent]="parentForm.get(question.id)" [controlName]="question.id" (onDisplayMobileTooltipEmitter)="displayMobileTooltipReceiver(question.helpText)">
        </app-multiple-inputbox>
      </div>


    </div>
  </ng-container>
  <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
    (primaryBtnClick)="alertTooltipPrimaryBtnClick()" (secondaryBtnClick)="alertSecondaryBtnClick()" [tooltipFlag]="true"></app-modal>
</div>
<ng-container *ngIf="showModalForCardRefresh">
  <app-modal [modalConfig]="alertCardRefreshModalConfig" (closeModal)="closeCardRefreshModal()" (primaryBtnClick)="alertPrimaryBtnClickinModal()"
  (secondaryBtnClick)="alertSecondaryCardRefreshBtnClick()" [saveDataFlag]="false"></app-modal>
</ng-container>